import dayjs from 'dayjs';
import { i18next } from '@frontend/i18n';
import { FormFieldActionTypes } from '@frontend/design-system';

type EndDateField = {
  value: unknown;
  'aria-invalid'?: boolean;
  error?: string;
};

type DateRangeState = {
  startDate: { value: unknown };
  endDate: EndDateField;
};

type DateRangeAction = {
  type: FormFieldActionTypes;
  payload?: {
    name?: string;
  };
};

export const applyDateRangeValidation = <T extends DateRangeState>(
  state: T,
  action: DateRangeAction,
  invalidRangeErrorMessage?: string
): T => {
  const startDateValue = typeof state.startDate.value === 'string' ? state.startDate.value : '';
  const endDateValue = typeof state.endDate.value === 'string' ? state.endDate.value : '';
  const startDate = dayjs(startDateValue);
  const endDate = dayjs(endDateValue);
  const isValidStartAndEndDate = startDate.isValid() && endDate.isValid();
  const isInvalidDateRange = startDate.isAfter(endDate, 'day');

  let newState = { ...state };

  if (action.payload?.name === 'endDate' && isValidStartAndEndDate) {
    newState = {
      ...newState,
      endDate: {
        ...newState.endDate,
        'aria-invalid': isInvalidDateRange,
        error: isInvalidDateRange
          ? invalidRangeErrorMessage || i18next.t('End date must be after the start date', { ns: 'schedule' })
          : '',
      },
    };
  }

  if (action.type === FormFieldActionTypes.Blur && action.payload?.name === 'startDate' && isValidStartAndEndDate) {
    newState = {
      ...newState,
      endDate: {
        ...newState.endDate,
        value: isInvalidDateRange ? startDateValue : newState.endDate.value,
        'aria-invalid': false,
        error: '',
      },
    };
  }

  return newState;
};
